import React, { ReactNode } from 'react';
import { Element } from '@/components/card/CardFeatured/CardFeatured.styles';

export interface CardFeaturedProps {
  title?: string;
  children?: ReactNode;
}

const CardFeatured = ({ children, ...props }: CardFeaturedProps) => {
  return <Element>{children}</Element>;
};

export default CardFeatured;
